import React from 'react';
import { Page } from '../../components';

export const Home = () => {
  return (
    <>
      <Page title="Admin App">{/* body content here*/}</Page>
    </>
  );
};
